import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import config from '../../../utils/confg.json'
const url = config.BackendUrl;


//| 'pending' | 'succeeded' | 'failed',
const initialState = {
    response: {},
    loading: 'idle',
    httpCode: 0,
    errorMsg: "",
    errorData: {},
  };
  

  export const getMainReportActions = createAsyncThunk(
    "Reports/getMainReport",
    async (dispatch, { rejectWithValue }) => {
      try {
  
        const { data } = await axios.post(url + "/Apps/API/Reports/getMain/ShopId/0/DeviceId/0/UserType/3/QRKey/0",{},
          {
            withCredentials: true
          })
        return data;
      } catch (err) {
  
        if (err.response) {
          return rejectWithValue({ error: err.message, status: err.response.status, data: err.response.data });
  
  
        }
  
  
      }
    }
  );




  












  

  export const MainReportsSlice = createSlice({

    name: "MainReport",
    initialState,
  
    reducers: {
      Rest: (state, action) => {
  
        state.response = {}
        state.loading = 'idle'
        state.httpCode = 0
        state.errorMsg = ""
        state.errorData = {}
  
      }
  
  
  
    },
  
  
  
    extraReducers: {
      [getMainReportActions.pending]: (state) => {
        state.loading = 'pending';
      },
      [getMainReportActions.fulfilled]: (state, action) => {
  
        state.loading = 'succeeded';
        state.httpCode = 200;
        state.response = action.payload;
      },
      [getMainReportActions.rejected]: (state, action) => {
  
        try {
          state.loading = 'failed';
          state.httpCode = action.payload.status;
          state.errorMsg = action.payload.error;
          state.response = {};
          if (action.payload.status === 409) {
            state.errorData = action.payload.data
          } else {
  
            state.response = {}
  
          }
        } catch {
  
          state.httpCode = 503;
          state.errorMsg = "service unavailable";
        }
      } ,





      







  
    }
  
  })
  
  
  export const { Rest } = MainReportsSlice.actions
  
  export default MainReportsSlice.reducer;
  